import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CrmCommandHandler from 'crm-command-handler/CrmCommandHandler';
import OnboardingTour from 'onboarding-tours/components/OnboardingTour';
import PlaybookModalHandler from '../../modals/PlaybookModalHandler';
import { RecordsFeatures } from '../../constants/crmFeatures';
import OnboardingTourModalsAsync from '../../modals/OnboardingTourModalsAsync';
import { delayUntilIdle } from '../utils/delayUntilIdle';
import ConnectEmailTourWrapperAsync from '../../modals/ConnectEmailTourWrapperAsync';
import UseCallingWidgetContainerAsync from './UseCallingWidgetContainerAsync';
import { getI18nProvider } from 'quartz-core/framework/i18n';
import ClonerFeedbackSurvey from './ClonerFeedbackSurvey';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProfilePopUpsContainer = ({
  onCommunicatorClick,
  objectType,
  subjectId,
  query
}) => {
  const {
    search
  } = useLocation();
  const searchParams = new URLSearchParams(search);
  const isClonedRecord = searchParams.get('isClonedRecord') === 'true';
  const [isAsyncComponentsRendered, setIsAsyncComponentsRendered] = useState(false);
  useEffect(() => {
    delayUntilIdle(() => setIsAsyncComponentsRendered(true));
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PlaybookModalHandler, {}), /*#__PURE__*/_jsx(CrmCommandHandler, {
      features: RecordsFeatures,
      i18nLoader: getI18nProvider(),
      onCommunicatorClick: onCommunicatorClick
    }), isClonedRecord && /*#__PURE__*/_jsx(ClonerFeedbackSurvey, {}), isAsyncComponentsRendered && /*#__PURE__*/_jsx(OnboardingTourModalsAsync, {}), isAsyncComponentsRendered && /*#__PURE__*/_jsx(OnboardingTour, {}, "onboarding-tour"), isAsyncComponentsRendered && /*#__PURE__*/_jsx(ConnectEmailTourWrapperAsync, {}), /*#__PURE__*/_jsx(UseCallingWidgetContainerAsync, {
      objectType: objectType,
      query: query,
      renderImmediately: (query === null || query === void 0 ? void 0 : query.interaction) === 'call',
      subjectId: subjectId
    })]
  });
};
export default ProfilePopUpsContainer;